import { render, staticRenderFns } from "./TagThird.vue?vue&type=template&id=c1aae5b4&scoped=true&"
import script from "./TagThird.vue?vue&type=script&lang=js&"
export * from "./TagThird.vue?vue&type=script&lang=js&"
import style0 from "./TagThird.vue?vue&type=style&index=0&id=c1aae5b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1aae5b4",
  null
  
)

export default component.exports